import { useAuth } from "@/features/authentication";
import { useIsMobile } from "@/hooks/use-is-mobile";
import { FunctionComponent, createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import {
  generateTrackData,
  sendTrackData,
  sendUserIdentifyData,
} from "../../utils/track-data";
import { AnalyticsContextProps, AnalyticsProviderProps } from "./segment.types";

const AnalyticsContext = createContext({} as AnalyticsContextProps);

export const AnalyticsProvider: FunctionComponent<AnalyticsProviderProps> = ({
  children,
}) => {
  const { userInfo } = useAuth();
  const { pathname } = useLocation();
  const { isMobile } = useIsMobile();

  const track: AnalyticsContextProps["track"] = (eventName, data) => {
    if (userInfo?.user) {
      const trackData = generateTrackData({
        ...data,
        userId: userInfo.user.id,
        userEmail: userInfo.profile?.email ?? "",
        value: {
          ...data?.value,
        },
        urlPage: pathname,
        origin: isMobile ? "web-mobile" : "web",
      });

      sendUserIdentifyData(userInfo);

      sendTrackData({ eventName, ...trackData });
    }
  };

  const contextValue = useMemo(() => ({ track }), [track]);

  return (
    <AnalyticsContext.Provider value={contextValue}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalytics = () => useContext(AnalyticsContext);
